import React, { useState } from 'react';
import Papa from 'papaparse';
import './CsvToJson.css';

function CsvToJson() {
  const [jsonData, setJsonData] = useState<any[] | null>(null);
  const [error, setError] = useState<string|null>('');
  document.title = "CSV to JSON Converter";

  const removeWhiteSpaceFromNames = (myData:any) => {
    const final:any[] =[];
    myData?.forEach((obj:any) =>{
      const result:any = {};
      Object.entries(obj).forEach(([key, data]) => {
        const newKey = key.replace(/\s|\/|#/g,'');
        result[newKey] = data;
      })
      final.push(result);
    });
    return final;
  }

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    setJsonData(null);
    const file = event.target.files&& event.target.files[0];

    if (!file) {
      setError('No file selected');
      return;
    }

    // Check if file is CSV
    if (!file.name.endsWith('.csv')) {
      setError('Please upload a CSV file');
      return;
    }

    Papa.parse(file, {
      header: true, // Treat first row as headers
      skipEmptyLines: true,
      complete: (result) => {
        const result2 = removeWhiteSpaceFromNames(result.data);
        setJsonData(result2);
        setError(null);
      },
      error: (err) => {
        setError('Error parsing CSV: ' + err.message);
        setJsonData(null);
      }
    });
  };

  return (
    <div className="CsvToJson">
      <h1>CSV to JSON Converter</h1>
      
      <div className="upload-section">
        <input
          type="file"
          accept=".csv"
          onChange={handleFileUpload}
        />
      </div>

      {error && (
        <div className="error">
          <p>{error}</p>
        </div>
      )}

      {jsonData && jsonData.length && (
        <div className="result">
          <h2>Converted JSON:</h2>
          <pre>{JSON.stringify(jsonData, null, 2)}</pre>
          <button onClick={() => {
            const blob = new Blob([JSON.stringify(jsonData, null, 2)], { type: 'application/json' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'converted.json';
            a.click();
            URL.revokeObjectURL(url);
          }}>
            Download JSON
          </button>
        </div>
      )}
    </div>
  );
}

export default CsvToJson;